import { type UseQueryResult, useQuery } from 'react-query';
import { ResidenceStatusService } from '../../services/wealthlane-customer-services';

const useGetResidenceStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const ResidenceStatusList = useQuery(
    ['getResidenceStatusList'],
    async () => {
      return await handleRequest(
        ResidenceStatusService.getApiCustomerApiAppResidenceStatusResidenceStatusList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return ResidenceStatusList;
};

export default useGetResidenceStatus;
